import { render } from "./ContentSwitchList.vue?vue&type=template&id=575ea44a"
import script from "./ContentSwitchList.vue?vue&type=script&lang=js"
export * from "./ContentSwitchList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__